import React from 'react';
import CityLandingPage from '../CityLandingPage/CityLandingPage';
import { cityContent } from '../../data/cityLandingContent';

const LandingPageLogrono = props => {
  return <CityLandingPage cityKey="Logrono" cityConfig={cityContent.logrono} {...props} />;
};

export default LandingPageLogrono;
